import preloadChunks from '@/routes/preloadChunks.util';

const signingsRoutes = [
  {
    path: 'templates',
    lazy: async () => ({
      Component: (await preloadChunks['templates.main']()).default,
    }),
    children: [
      {
        path: ':workflowId',
        lazy: async () => ({
          Component: (await preloadChunks['templates.workflow']()).default,
        }),
      },
    ],
  },
];

export default signingsRoutes;
